/* eslint-disable no-await-in-loop */
/* eslint-disable no-unreachable-loop */
import React from 'react';

import Check from '@/components/commons/icons/Check';
import ThumbsUpSolid from '@/components/commons/icons/ThumbsUpSolid';

import style from './ModalStyles.module.css';
import Slider from './Slider';

const getProperties = (
    index: number,
    selected: number,
    buttonBackground: string,
    labelColor: string,
    rightIcon: any,
    defaultBorder: string,
) => {
    const properties = {
        buttonBackground: buttonBackground || 'cirrusWhite',
        labelColor,
        borders: `border-[1px] border-${defaultBorder || 'cleanSlate'}`,
        rightIcon,
    };

    if (selected !== 99) {
        properties.borders = 'border-[1px] border-transparent';
        if (selected === index) {
            properties.rightIcon = <Check className="w-4 h-4 text-white" />;
            properties.labelColor = 'cirrusWhite';
            properties.buttonBackground = 'green-400';
            return properties;
        }

        properties.rightIcon = rightIcon;
        properties.labelColor = 'gray';
        properties.buttonBackground = 'shadeStoneGray';
        return properties;
    }

    return properties;
};

export const buttonTypes = (
    buttonsAlign,
    data,
    triggerAnswer,
    index,
    selected,
    showSliderConfirm,
    optionPreSelected,
) => {
    const properties = getProperties(
        index,
        selected,
        data.background,
        data.fontColor,
        data.iconRight,
        data.border,
    );

    const buttons = {
        buttons: (
            <button
                key={data.key}
                type="button"
                data-tooltip-id="tip"
                title={data.label}
                aria-label={data.label}
                onClick={() => triggerAnswer(index, data.value)}
                className={`${properties.borders} w-full rounded-lg bg-${properties.buttonBackground} flex items-center justify-center py-2 px-4 my-2 pt-[6px] mr-0 ${buttonsAlign === 'row' && index === 0 ? 'mr-4' : ''}`}
            >
                <div className="flex items-center justify-center px-5 py-1">
                    {data.iconLeft && (
                        <div className="mr-4 w-4">
                            {data.iconLeft}
                        </div>
                    )}
                    <p className={`font-medium min-w-[65px] text-${properties.labelColor}`}>{selected === index ? data.nextLabel || data.label : data.label}</p>
                    {properties.rightIcon && (
                        <div className="ml-2 w-4">
                            {properties.rightIcon}
                        </div>
                    )}
                </div>
            </button>
        ),
        slider: (
            <div key="contact-game-slider" className="flex flex-col items-center justify-center py-2 px-4 mb-2">
                <Slider
                    label=""
                    name={`slider-${index}`}
                    externalStyles={`w-[350px] bg-lightGray ${style.step}`}
                    defaultValue={data.defaultValue}
                    options={data.options}
                    onChange={triggerAnswer}
                    showSliderConfirm={showSliderConfirm}
                />
                <button
                    type="button"
                    data-tooltip-id="tip"
                    title="Continue"
                    aria-label="Continue"
                    onClick={() => triggerAnswer(
                        0,
                        showSliderConfirm
                            ? optionPreSelected
                            : data.defaultValue,
                        false,
                    )}
                    className={`${properties.borders} w-[250px] rounded-lg bg-${properties.buttonBackground} flex items-center justify-center py-2 px-4 mt-20 pt-[6px] mr-0`}
                >
                    {showSliderConfirm
                        ? (
                            <div className="flex items-center justify-center px-5 py-1">
                                <p className={`font-medium text-${properties.labelColor}`}>Continue</p>
                            </div>
                        )
                        : (
                            <div className="flex items-center justify-center px-5 py-1">
                                <div className="mr-2 w-4">
                                    <ThumbsUpSolid className="w-4 h-4 text-cleanSlate" />
                                </div>
                                <p className={`font-medium min-w-[65px] text-${properties.labelColor}`}>This is fine</p>
                            </div>
                        )}
                    {properties.rightIcon && (
                        <div className="ml-2 w-4">
                            {properties.rightIcon}
                        </div>
                    )}
                </button>
            </div>
        ),
    };

    if (data.options) {
        return buttons.slider;
    }

    return buttons.buttons;
};

export const formatAnswer = (question, answer, skipped = false) => {
    let output = {
        toSend: {},
        toReview: {},
    };
    if (!skipped) {
        output = {
            toSend: {
                id: question.id,
                attributes: {
                    response: answer,
                    status: 'answered',
                },
            },
            toReview: {
                question,
                answer,
                skipped: false,
            },
        };
    } else {
        output = {
            toSend: {
                id: question.id,
                attributes: {
                    status: 'skipped',
                },
            },
            toReview: {
                question,
                answer,
                skipped: true,
            },
        };
    }
    return output;
};

export const addAnswerToPool = (totalAnswers, thisAnswer) => {
    let output = [];
    const totalAnswersCopy = [...totalAnswers];
    if (totalAnswers.length > 0) {
        const alreadyAnswered = totalAnswers.findIndex(
            (answer) => answer.question.id === thisAnswer.question.id,
        );
        if (alreadyAnswered !== -1) {
            totalAnswersCopy[alreadyAnswered] = thisAnswer;
            output = totalAnswersCopy;
        } else {
            output = [...totalAnswers, thisAnswer];
        }
    } else {
        output = [thisAnswer];
    }
    return output;
};

export const categorizeQuestions = (data) => {
    const categories = {
        circle: [],
        primary_email: [],
        name: [],
        photo: [],
        mapping: [],
        birthday: [],
        human: [],
    };

    if (data.length === 0) {
        return categories;
    }

    data.forEach((element) => categories[element.question.questionType].push(element));
    return categories;
};

export const renderAnswers = () => (
    <div />
);

export const processQueue = async (
    setIsProcessing,
    requestQueue,
    setRequestQueue,
    setErrorAmounts,
    setCurrentlySending,
) => {
    setIsProcessing(true);
    while (requestQueue.length > 0) {
        const currentRequest = requestQueue[0].request;
        setCurrentlySending(requestQueue[0].questionId);
        let success = false;
        let attempts = 0;

        while (!success && attempts < 10) {
            attempts += 1;
            try {
                const response = await currentRequest();
                if (response.data.updateContactGameQuestion.errors.length === 0) {
                    success = true;
                }
            } catch (_error) {
                if (attempts >= 10) {
                    setRequestQueue((prevQueue) => prevQueue.slice(1));
                    setErrorAmounts((prevErrorAmounts) => prevErrorAmounts + 1);
                }
            }
        }
        if (success) {
            setRequestQueue((prevQueue) => prevQueue.slice(1));
            setCurrentlySending('');
            break;
        } else {
            break;
        }
    }
    setIsProcessing(false);
};

export const circleName = ['Close', 'Medium', 'Distant'];

export const formattedCircle = (circle) => {
    if (circle === null) {
        return 'New';
    }
    return circleName[circle];
};

export const extractStatistics = (data) => {
    if (!data || data.length === 0) {
        return [];
    }

    const allContactsCircles = [0, 0, 0, 0];
    const contactsCirclesUpdated = [0, 0, 0, 0];

    data.forEach((contact) => {
        // TODO: What in the crystal meth...
        if (contact.proposedCircle === null) {
            allContactsCircles[3] += 1;
        } else {
            allContactsCircles[contact.proposedCircle] += 1;
        }

        if (contact.chosenCircle === null) {
            return null;
        }

        if (contact.chosenCircle === contact.proposedCircle) {
            if (contact.proposedCircle === null) {
                contactsCirclesUpdated[3] += 1;
            } else {
                contactsCirclesUpdated[contact.proposedCircle] += 1;
            }
        }
        return null;
    });

    const calculatePercentage = (index) => Math.round((
        contactsCirclesUpdated[index]
        / allContactsCircles[index]
    )
        * 100)
        || 0;

    const circlesPercentage = {
        0: calculatePercentage(0),
        1: calculatePercentage(1),
        2: calculatePercentage(2),
        3: calculatePercentage(3),

    };
    return circlesPercentage;
};
